var _excluded = ["maxLength", "focused"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { CommentInput, CommentInputWithCounter } from '.';
var DefaultCommentInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var maxLength = _ref.maxLength,
    focused = _ref.focused,
    props = _objectWithoutProperties(_ref, _excluded);
  return maxLength && maxLength > 0 ? /*#__PURE__*/React.createElement(CommentInputWithCounter, _extends({
    ref: ref
  }, props, {
    maxLength: maxLength
  })) : /*#__PURE__*/React.createElement(CommentInput, _extends({
    ref: ref
  }, props));
});
DefaultCommentInput.displayName = 'DefaultCommentInput';
DefaultCommentInput.propTypes = {
  /** Max characters allowed (activates character count) */
  maxLength: PropTypes.number
};
export default DefaultCommentInput;
//# sourceMappingURL=DefaultCommentInput.js.map